import { Row } from "@/components";

import { cn } from "@/lib/utils";
import { JobLiquidity } from "@/types";

const liquidityWaveClassNames: Record<JobLiquidity, string> = {
  [JobLiquidity.UNKNOWN]: "",
  [JobLiquidity.THIN]: "h-2 opacity-20",
  [JobLiquidity.MODERATE]: "h-4 opacity-20",
  [JobLiquidity.LIQUID]: "h-12 opacity-20",
  [JobLiquidity.VERY_LIQUID]: "h-20 opacity-20",
};
const LIQUIDITY_WAVE_PATHS = [
  "M0 0H2400V160C2320 140 2240 182 2160 154C2000 130 1840 190 1680 166C1520 138 1360 184 1200 160C1040 140 880 182 720 154C560 130 400 190 240 166C160 150 80 174 0 160Z",
  "M0 0H2400V156C2320 132 2240 186 2160 164C2000 136 1840 188 1680 152C1520 130 1360 184 1200 156C1040 132 880 186 720 164C560 136 400 188 240 152C160 140 80 170 0 156Z",
  "M0 0H2400V164C2320 146 2240 180 2160 152C2000 128 1840 186 1680 172C1520 144 1360 190 1200 164C1040 146 880 180 720 152C560 128 400 186 240 172C160 156 80 178 0 164Z",
];

export const JobLiquidityWave = ({
  className,
  liquidity,
}: {
  className?: string;
  liquidity: JobLiquidity;
}) => {
  /* Helpers */
  const prefersReducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches;

  /* Render */
  const render = () => {
    if (liquidity === JobLiquidity.UNKNOWN) return null;

    return (
      <Row
        className={cn(
          "liquidity-glow-pulse pointer-events-none absolute inset-x-0 bottom-0 z-0",
          liquidityWaveClassNames[liquidity],
          className,
        )}
      >
        <svg
          className="h-full w-full rotate-180"
          preserveAspectRatio="none"
          viewBox="0 0 1200 200"
        >
          <defs>
            <linearGradient
              id="toolbar-liquidity-wave-gradient"
              x1="0"
              x2="0"
              y1="0"
              y2="1"
            >
              <stop
                offset="0"
                stopColor="hsl(var(--color-primary-700))"
                stopOpacity="1"
              />
              <stop
                offset="1"
                stopColor="hsl(var(--color-primary-700))"
                stopOpacity="0.2"
              />
            </linearGradient>
          </defs>
          <g>
            {!prefersReducedMotion ? (
              <animateTransform
                attributeName="transform"
                dur="48s"
                from="0 0"
                repeatCount="indefinite"
                to="-1200 0"
                type="translate"
              />
            ) : null}
            <path
              d={LIQUIDITY_WAVE_PATHS[0]}
              fill="url(#toolbar-liquidity-wave-gradient)"
            >
              {!prefersReducedMotion ? (
                <animate
                  attributeName="d"
                  calcMode="spline"
                  dur="3.5s"
                  keySplines="0.45 0 0.55 1;0.45 0 0.55 1;0.45 0 0.55 1"
                  keyTimes="0;0.33;0.66;1"
                  repeatCount="indefinite"
                  values={`${LIQUIDITY_WAVE_PATHS.join(";")};${LIQUIDITY_WAVE_PATHS[0]}`}
                />
              ) : null}
            </path>
          </g>
        </svg>
      </Row>
    );
  };

  return render();
};
